import React, { useEffect, useState } from "react";
import SwiperCore, { Autoplay, FreeMode, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import styles from "./SwipeCalendar.module.scss";
import useWindowResize from "../../hooks/useWindowResize";

SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);

const SwipeCalendar = ({ bigSlides = false, items, title, smallImg=false, calendarStyle='light' }) => {
  const [list, setList] = useState([]);
  const isBelowMedium = useWindowResize(768);
  //const swiper = useSwiper();

  useEffect(() => {
    if (items) {
      setList(
        items.map((d, i) => (
          <SwiperSlide key={i} className={calendarStyle == 'dark' ? styles.darkCalendar : styles.lightCalendar}>
            <div className={styles.calendarItem}>
              <div className={styles.firstRow}>
                <div className={styles.day}>
                  <span>{d.day}</span>
                  <span>{d.month}</span>
                </div>
                <div className={styles.title}>
                  <span>{d.title}</span>
                  <span>{d.subtitle}</span>
                </div>
              </div>
              <div className={styles.text} dangerouslySetInnerHTML={{__html: d.text}}></div>
            </div>
          </SwiperSlide>
        ))
      );
    }
  }, [items]);

  return (
    <div className={styles.SwipeCalendar}>
      {title && <div className={styles.cardIntroText} style={{ display: bigSlides && title ? "block" : "block" }}>{title.toUpperCase()}</div>}
      <div>
        <div className={bigSlides ? 'imageCarousel' : 'imageCarouselSwipe'}>
          <Swiper
            onInit={swiper => {swiper.slideTo(0, 0);}}
            pagination={{clickable: true, el: '.swiperCalendarPagination'}}
            slidesPerView={"auto"}
            modules={[Pagination]}
            spaceBetween={30}
            centeredSlides={true}
            speed={2000}
            autoplay={{
              disableOnInteraction: false,
            }}
          >
            {list}
          </Swiper>
          <div className="swiperCalendarPagination"></div>
        </div>
      </div>
    </div>
  );
};

export default SwipeCalendar;
